import Vue from 'vue'
import Page from '@/components/Page.vue'
import FixTabFooterPage from '@/components/FixTabFooterPage.vue'
import UpperLevel from '@/components/UpperLevel.vue'
import Pagination from '@/components/Pagination.vue'

import Autocomplete from '@/components/Autocomplete.vue'
import UploadButton from '@/components/UploadButton.vue'
import Range from '@/components/Range.vue'
import CopyButton from '@/components/CopyButton.vue'
import OtherSelect from '@/components/OtherSelect.vue'
import OtherSelectLine from '@/components/OtherSelectLine.vue'
import SwitchBtn from '@/components/SwitchBtn.vue'
import CountryMobile from '@/components/CountryMobile.vue'
import CountryMobileWithSearch from '@/components/CountryMobileWithSearch.vue'
import SelectAllOption from '@/components/SelectAllOption.vue'
import UploadImg from '@/components/UploadImg.vue'
import UploadFile from '@/components/UploadFile.vue'
import UploadPlusIcon from '@/components/UploadPlusIcon.vue'
import WangEditor from '@/components/WangEditor.vue'
import InputNumberStep from '@/components/InputNumberStep.vue'
import Signature from '@/components/Signature.vue'
import ZmTimePicker from '@/components/ZmTimePicker.vue'

import UploadImgAndFile from '@/components/UploadImgAndFile.vue'
import DateInput from '@/components/DateInput.vue'
import CompanyIcon from '@/components/CompanyIcon.vue'

Vue.component('Page', Page)
Vue.component('FixTabFooterPage', FixTabFooterPage)
Vue.component('UpperLevel', UpperLevel)
Vue.component('Pagination', Pagination)


Vue.component('Autocomplete', Autocomplete)
Vue.component('UploadButton', UploadButton)
Vue.component('Range', Range)
Vue.component('CopyButton', CopyButton)
Vue.component('OtherSelect', OtherSelect)
Vue.component('OtherSelectLine', OtherSelectLine)
Vue.component('SwitchBtn', SwitchBtn)
Vue.component('CountryMobile', CountryMobile)
Vue.component('CountryMobileWithSearch', CountryMobileWithSearch)
Vue.component('SelectAllOption', SelectAllOption)
Vue.component('UploadImg', UploadImg)
Vue.component('UploadFile', UploadFile)
Vue.component('UploadPlusIcon', UploadPlusIcon)
Vue.component('WangEditor', WangEditor)
Vue.component('InputNumberStep', InputNumberStep)
Vue.component('Signature', Signature)
Vue.component('ZmTimePicker', ZmTimePicker)

Vue.component('UploadImgAndFile', UploadImgAndFile)
Vue.component('DateInput', DateInput)
Vue.component('CompanyIcon', CompanyIcon)
